<template>
  <v-card color="white" class="rounded mb-4" height="400px" elevation="0">
    <v-card-title class="subheading dark-header-bg">
      <div>
        <span class="white-text pl-2 font-weight-bold">Engagement Leaders</span
        ><span class="ml-2">&#127942;</span>
      </div>
    </v-card-title>
    <v-card-text>
      <v-flex v-if="leadersLoading">Loading...</v-flex>
      <v-flex
        v-if="
          !leadersLoading &&
          leadersList &&
          leadersList.topSenders.length <= 0 &&
          leadersList.topReceivers.length <= 0
        "
      >
        <div>No data to show at the moment</div>
      </v-flex>
      <v-flex
        v-if="
          !leadersLoading &&
          leadersList &&
          (leadersList.topSenders.length > 0 ||
            leadersList.topReceivers.length > 0)
        "
      >
        <div>
          <div class="mb-1">
            <span class="caption text-uppercase font-weight-medium grey--text"
              >Top Active</span
            >
            <span class="ml-2">&#127894;</span>
          </div>
          <v-divider></v-divider>
          <v-flex
            v-if="
              !leadersLoading &&
              leadersList &&
              leadersList.topSenders.length <= 0
            "
          >
            <div>No data to show at the moment</div>
          </v-flex>
          <div v-else style="overflow-y: auto; height: 130px">
            <v-list dense>
              <template v-for="(ts, tsIndex) in leadersList.topSenders">
                <v-list-tile avatar :key="ts.userId">
                  <v-list-tile-avatar size="32" class="mx-2">
                    <span class="subheading mr-3">{{ tsIndex + 1 }}.</span>
                    <img :src="ts.userPicture" :alt="ts.userName" />
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title
                      class="font-weight-bold text-uppercase"
                      >{{ ts.userName }}</v-list-tile-title
                    >
                  </v-list-tile-content>

                  <!-- <v-list-tile-action>
                  <v-flex
                    class="
                      subheading
                      font-weight-bold
                      grey--text
                      text--darken-1
                    "
                    >{{ ts.totalEngagement }}</v-flex
                  >
                </v-list-tile-action> -->
                </v-list-tile>
                <v-divider :key="tsIndex"></v-divider>
              </template>
            </v-list>
          </div>
        </div>
        <div class="mt-3">
          <div class="mb-1">
            <span class="caption text-uppercase font-weight-medium grey--text"
              >Top Ovations Receivers</span
            >
            <span class="ml-2">&#127881;</span>
          </div>
          <v-divider></v-divider>
          <v-flex
            v-if="
              !leadersLoading &&
              leadersList &&
              leadersList.topReceivers.length <= 0
            "
          >
            <div>No data to show at the moment</div>
          </v-flex>
          <div v-else style="overflow-y: auto; height: 130px">
            <v-list dense>
              <template v-for="(tr, trIndex) in leadersList.topReceivers">
                <v-list-tile avatar :key="tr.userId">
                  <v-list-tile-avatar size="32" class="mx-2">
                    <span class="subheading mr-3">{{ trIndex + 1 }}.</span>
                    <img :src="tr.userPicture" :alt="tr.userName" />
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title
                      class="font-weight-bold text-uppercase"
                      >{{ tr.userName }}</v-list-tile-title
                    >
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-flex
                      class="subheading font-weight-bold grey--text text--darken-1"
                      >{{ tr.totalOvations }}</v-flex
                    >
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider :key="trIndex"></v-divider>
              </template>
            </v-list>
          </div>
        </div>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "axios";

export default {
  name: "EngagementLeaders",
  data() {
    return {
      leadersLoading: false,
      leadersList: { topReceivers: [], topSenders: [] },
    };
  },
  methods: {
    getLeadersList() {
      this.leadersList = { topReceivers: [], topSenders: [] };
      this.leadersLoading = true;

      axios
        .get(
          "/api/org/engagementleaders/" +
            this.$store.getters.getParentOrgIdentifier,
          this.$store.state.axiosConfig
        )
        .then((response) => {
          this.leadersList = response.data;
          this.leadersLoading = false;
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Could not retrieved Engagement Leaders list.<br>Response: " +
              e.response.data.message,
            messageType: "error",
          });

          this.leadersList = { topReceivers: [], topSenders: [] };
          this.leadersLoading = false;
        });
    },
  },
  beforeMount() {
    this.getLeadersList();
  },
};
</script>
